import script from "./DispatchOrderLineDetailsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DispatchOrderLineDetailsTab.vue?vue&type=script&setup=true&lang=js"

import "./DispatchOrderLineDetailsTab.vue?vue&type=style&index=0&id=94b37946&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94b37946"]])

export default __exports__